module.exports = __webpack_public_path__ + "img/whatsappbubble.598aca5d.svg";